import type { Rule } from 'antd/es/form';

const RATE_CARD_TEXT_PATTERN = /^[A-Za-z0-9@#$%^&\-_ +–=<>()/!*,.?;:]+$/;

/** Optional text fields (product, tactic) — allow empty, validate when present. */
export const optionalRateCardTextRule: Rule = {
  validator: (_, value: string | undefined) => {
    if (!value || RATE_CARD_TEXT_PATTERN.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Invalid characters'));
  }
};

/** Multiselect tags (formats) — allow empty, validate each tag when present. */
export const optionalRateCardTagsRule: Rule = {
  validator: (_, value: string[] | undefined) => {
    if (!value?.length) {
      return Promise.resolve();
    }
    const invalid = value.find((tag) => !RATE_CARD_TEXT_PATTERN.test(tag));
    if (invalid) {
      return Promise.reject(new Error(`Invalid format: ${invalid}`));
    }
    return Promise.resolve();
  }
};
